import React from "react";
import { Button, Card, Col, List, Row, Spin, Tooltip } from "antd";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import useCreaSearch from "../../hooks/useCreaSearch";
import CreaFilters from "../../components/CreaFilters/CreaFilters";
import CreaItem from "../../components/Crea/CreaItem";
import BannerTop from "../../components/BannerTop/BannerTop";
import { l, formatNumber } from "../../libs/localization";
import usePermissions from "../../hooks/usePermissions";
import { getFeatures } from "../../libs/features";
import { getFromLocalStorage } from "../../libs/helpers/localstorage";

const CreaSearch = () => {
  const {
    dataForm,
    setDataForm,
    brandAdvertiserFilters,
    setBrandAdvertiserFilters,
    order,
    orderDir,
    pageSize,
    pageNum,
    results,
    loading,
    handleOrder,
    handlePageChange,
    resetSearch,
  } = useCreaSearch();

  const permissions = usePermissions();
  const features = getFeatures();
  const tenant = getFromLocalStorage("lefacWebTenant")?.data;

  const orderLabel = (value, key) => (
    <Button
      type="link"
      className={`${
        order === value ? "selected" : ""
      } searchPage__orders-button`}
      onClick={() => handleOrder(value)}
      style={{ fontWeight: order === value ? "bold" : "normal" }}
    >
      {key}
      {order === value && (
        <span className="searchPage__orders-icon ml-1">
          {orderDir === "asc" ? <UpOutlined style={{ fontSize: "10px" }} /> : <DownOutlined style={{ fontSize: "10px" }} />}
        </span>
      )}
    </Button>
  );

  return (
    <>
      <BannerTop small>
        <h1 className="mt-4 orange-title">{l("PAGES.CREA.SEARCH.TITLE")}</h1>
      </BannerTop>

      <div className="searchPage__filters animation fadein-up slow">
        <Card
          bordered={false}
          style={{ borderRadius: "10px" }}
          className="companyPage__body-card companyPage__body-card--custom customCard"
        >
          <CreaFilters
            dataForm={dataForm}
            setDataForm={setDataForm}
            features={features}
            permissions={permissions}
            tenant={tenant}
            loadingSearch={loading}
            brandAdvertiserFilters={brandAdvertiserFilters}
            setBrandAdvertiserFilters={setBrandAdvertiserFilters}
            renderExtraActions={() => (
              <Row justify="end">
                <Button type="default" onClick={resetSearch}>
                  {l("COMMON.RESET")}
                </Button>
              </Row>
            )}
          />
        </Card>
      </div>

      <div className="searchPage__results mt-4">
        <Row align="middle" className="searchPage__orders" style={{ height: 60, padding: "0 16px" }}>
          <Col className="orange-title" style={{ fontWeight: "normal", marginRight: 15 }}>
            {l("COMMON.ORDER_BY")}
          </Col>
          <Col span={12}>
            {orderLabel("title", l("PAGES.SEARCH.ORDER.TITLE"))}
            {orderLabel("date", l("PAGES.SEARCH.ORDER.DATE"))}
            {orderLabel("duration", l("PAGES.CREA.SEARCH.DURATION"))}
          </Col>
          <Col span={8} align="right">
            <h2 style={{ fontWeight: "bold", margin: 0 }} className="orange-title">
              {l("PAGES.CREA.SEARCH.CREAS_FOUND")}:{" "}
              <span className="orange-title">
                {formatNumber(results?.totalResults || 0)}
              </span>
            </h2>
          </Col>
        </Row>

        <div className="animation fadein-right slow">
          {loading ? (
            <div className="text-center mt-5" style={{ width: "100%", minHeight: "200px" }}>
              <Spin className="mt-5" />
            </div>
          ) : (
            <List
              className="searchPage__list"
              itemLayout="vertical"
              dataSource={results?.data || []}
              locale={{
                emptyText: (
                  <div style={{ padding: "40px 0", textAlign: "center", color: "#999" }}>
                    {l("COMMON.NO_DATA")}
                  </div>
                ),
              }}
              renderItem={(item) => (
                <div className="searchPage__item-more animation fadein-right slow">
                  <List.Item className="searchPage__item">
                    <CreaItem item={item} />
                  </List.Item>
                </div>
              )}
              pagination={
                results?.totalResults > 0
                  ? {
                      current: pageNum,
                      pageSize: pageSize,
                      total: results?.totalResults,
                      onChange: handlePageChange,
                      showSizeChanger: true,
                      pageSizeOptions: ["10", "15", "20", "50"],
                      position: "bottom",
                    }
                  : false
              }
            />
          )}
        </div>
      </div>
    </>
  );
};

export default CreaSearch;
